import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

function base(props: IconProps) {
  return {
    viewBox: '0 0 24 24',
    width: 18,
    height: 18,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true as const,
    ...props,
  };
}

export function IconCap(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M2.8 10.2 12 4.6l9.2 5.6L12 16.2 2.8 10.2Z" />
      <path d="M6 12.4v4.1c2.2 1.6 9.8 1.6 12 0v-4.1" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M20.6 10.6v5.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

export function IconGrid(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.4" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.4" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.4" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.4" />
    </svg>
  );
}

export function IconTablet(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="6" y="2.5" width="12" height="19" rx="2.2" />
      <path d="M10 18.5h4" />
    </svg>
  );
}

export function IconQr(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.2" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.2" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.2" />
      <path d="M14 14h2.5v2.5H14zM17.5 14H20v6h-6v-2.5" />
    </svg>
  );
}

export function IconApps(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.4" />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.4" />
      <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.4" />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.4" />
    </svg>
  );
}

export function IconRocket(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 19c-2.4-1.2-4-3.8-4-6.6 0-4.2 2.6-8.1 4-9.4 1.4 1.3 4 5.2 4 9.4 0 2.8-1.6 5.4-4 6.6Z" />
      <path d="M9.2 14.2 6 18.5M14.8 14.2 18 18.5" />
      <circle cx="12" cy="10.2" r="1.3" />
    </svg>
  );
}

export function IconShield(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3.5 19 6.4v5.3c0 4.2-2.8 7.6-7 8.8-4.2-1.2-7-4.6-7-8.8V6.4L12 3.5Z" />
      <path d="m9.2 12 1.9 1.9 3.8-4" />
    </svg>
  );
}

export function IconScroll(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7 5.5h10a2 2 0 0 1 2 2V19H9a2 2 0 0 1-2-2V5.5Z" />
      <path d="M7 5.5A2.5 2.5 0 0 0 4.5 8V17" />
      <path d="M10 10h6M10 13.5h6" />
    </svg>
  );
}

export function IconGear(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M12 3.6v2.2M12 18.2v2.2M3.6 12h2.2M18.2 12h2.2M6.1 6.1l1.6 1.6M16.3 16.3l1.6 1.6M17.9 6.1l-1.6 1.6M7.7 16.3l-1.6 1.6" />
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="11" cy="11" r="6.2" />
      <path d="m16 16 4 4" />
    </svg>
  );
}

export function IconBell(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 16.5V11a6 6 0 1 1 12 0v5.5l1.2 1.8H4.8L6 16.5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

export function IconMail(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <path d="m4.5 7.5 7.5 6 7.5-6" />
    </svg>
  );
}

export function IconLock(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="5.5" y="10.5" width="13" height="10" rx="2" />
      <path d="M8.2 10.5V8a3.8 3.8 0 0 1 7.6 0v2.5" />
    </svg>
  );
}

export function IconEye(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M2.8 12s3.4-6.2 9.2-6.2S21.2 12 21.2 12 17.8 18.2 12 18.2 2.8 12 2.8 12Z" />
      <circle cx="12" cy="12" r="2.4" />
    </svg>
  );
}

export function IconEyeOff(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 3 21 21" />
      <path d="M9.9 5.4A10 10 0 0 1 12 5.2c5.8 0 9.2 6.8 9.2 6.8a16 16 0 0 1-3.3 3.8M6.4 7.6A16 16 0 0 0 2.8 12s3.4 6.2 9.2 6.2c1.1 0 2.1-.2 3.1-.6" />
    </svg>
  );
}

export function IconWifi(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M5 12.2A9.4 9.4 0 0 1 12 9.4a9.4 9.4 0 0 1 7 2.8" />
      <path d="M8.2 15.2A5.2 5.2 0 0 1 12 13.8a5.2 5.2 0 0 1 3.8 1.4" />
      <circle cx="12" cy="18.2" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconWifiOff(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 3 21 21" />
      <path d="M8.2 15.2A5.2 5.2 0 0 1 12 13.8c.5 0 1 .1 1.5.2" />
      <path d="M5 12.2A9.4 9.4 0 0 1 12 9.4c.7 0 1.4.1 2 .2M17.5 11.4c.5.2 1 .5 1.5.8" />
      <circle cx="12" cy="18.2" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconWarn(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 4.2 21 19.5H3L12 4.2Z" />
      <path d="M12 10v4.2" />
      <path d="M12 17.2h.01" />
    </svg>
  );
}

export function IconPlus(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function IconUpload(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 16V6" />
      <path d="m8 9.5 4-4 4 4" />
      <path d="M5 19h14" />
    </svg>
  );
}

export function IconChart(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 19h16" />
      <path d="M7 16V11" />
      <path d="M12 16V7" />
      <path d="M17 16v-6" />
    </svg>
  );
}

export function IconClock(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4.2l2.6 1.6" />
    </svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="8" />
      <path d="m8.6 12.2 2.3 2.3 4.6-5" />
    </svg>
  );
}

export function IconX(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="8" />
      <path d="m9 9 6 6M15 9l-6 6" />
    </svg>
  );
}

export function IconArrow(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

export function IconDownload(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 5v10" />
      <path d="m8 12.5 4 4 4-4" />
      <path d="M5 19h14" />
    </svg>
  );
}

export function IconCopy(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

export function IconDots(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="6" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="18" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconCloud(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7.5 17.5h9.2A4.2 4.2 0 0 0 18 9.4 6 6 0 0 0 6.4 10 3.8 3.8 0 0 0 7.5 17.5Z" />
      <path d="M12 11.5v5M9.8 13.2 12 11l2.2 2.2" />
    </svg>
  );
}

export function IconFilter(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 6h16l-6.2 7.2V18l-3.6 2v-6.8L4 6Z" />
    </svg>
  );
}

export function IconBook(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M5 5.5A2.5 2.5 0 0 1 7.5 4H19v14.5H7.8A2.3 2.3 0 0 0 5.5 21" />
      <path d="M5 5.5v13.2A2.3 2.3 0 0 1 7.5 21H19" />
    </svg>
  );
}

export function IconStethoscope(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 4v7a4 4 0 0 0 8 0V4" />
      <path d="M6 4H4.8M14 4h1.2" />
      <path d="M14 11a6 6 0 0 0 6 6h0a2.2 2.2 0 0 1 0 4.4" />
      <circle cx="20" cy="20.4" r="1.6" />
    </svg>
  );
}
